"use client"
import { useState } from "react";
import Image from "next/image";
import { Images } from "@assets/assets";

export default function VideoSection() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  return (
    <div className="flex flex-col gap-10">
      <div className="w-full lg:flex items-center justify-center box-border">
        <div className="relative w-full aspect-video max-h-[730px] overflow-hidden group cursor-pointer bg-black">
          {!isVideoPlaying ? (
            /* Custom Thumbnail Overlay */
            <div
              className="absolute inset-0 z-10"
              onClick={() => setIsVideoPlaying(true)}
            >
              <Image
                src={Images?.YoutubeThumbNew}
                alt="Video Thumbnail"
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                className="object-cover transition-transform duration-700 group-hover:scale-105"
              />

              <div className="absolute inset-0 flex items-center justify-center bg-black/10 group-hover:bg-black/30 transition-all">
                <div className="relative w-[68px] h-[48px] flex items-center justify-center rounded-[12px] bg-[#FF0000] transition-transform duration-300 group-hover:scale-110 shadow-xl">
                  <div
                    className="w-0 h-0 
                     border-y-[10px] border-y-transparent 
                     border-l-[18px] border-l-white 
                     ml-1"
                  />
                </div>
              </div>
            </div>
          ) : (
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/e5XW9PPsAPY?autoplay=1&rel=0"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          )}
        </div>
      </div>
    </div>
  );
}
